export default "__VITE_ASSET__f83d282a__"